import React from "react";
import "./app.module.scss";
import { ReduxProvider } from "../../store/ReduxProvider";
import { RouterProvider } from "react-router-dom";
import { router } from "../../router/router";

function App() {
  return (
    <ReduxProvider>
      <RouterProvider router={router} />
    </ReduxProvider>
  );
}

export default App;
